// アニメーション
$(function () {
    $(window).scroll(function () {
        $(".anim").each(function () {
            var scroll = $(window).scrollTop();
            var blockPosition = $(this).offset().top;
            var windowHeihgt = $(window).height();
            if (scroll > blockPosition - windowHeihgt + 150) {
                $(this).addClass("is-animated");
            }
        });
    });
});

// アンカーリンク
$(function () {
    $('a[href^="#"]').click(function () {
        let speed = 800;
        let href = $(this).attr("href");
        let target = $(href == "#" || href == "" ? 'html' : href);
        let position = target.offset().top;
        $("html, body").animate({ scrollTop: position }, speed, "swing");
        return false;
    });
});

// ハンバーガーメニュー
$(function () {
    $('.menu').on('click', function () {
    $('.sp_nav').slideDown(200);
    $('body').toggleClass('noscroll');
    });
    
    $('.sp_nav li a').on('click', function () {
    $('.sp_nav').slideUp(200);
    $('body').toggleClass('noscroll');
    });
    $('.sp_nav_close').on('click', function () {
    $('.sp_nav').slideUp(200);
    $('body').toggleClass('noscroll');
    });
});

// スクロールヘッダー
$(function () {
$(window).on('scroll', function () {
    if (300  < $(this).scrollTop()) {
        $('.header').addClass('active');
    } else {
        $('.header').removeClass('active');
    }
});
});

        $(function () {
            /* 「同意する」チェックイベント */
            $('#Agree').on('change', function () {
                if ($(this).prop("checked")) {
                    $('.link-btn').addClass("active");
                } else {
                    $('.link-btn').removeClass("active");
                }
            });

        });